import './css/App.css';

import { useState, useEffect } from 'react';

import { useSelector } from 'react-redux';

// Selectors

import { 
	getCurrentPage,
	getCurrentPageProps
} from './store/appStateReducers';


import store from './store/store';

import {
	LoginPage,
	LoadingPage,
	SelectAppPage,
	AppPage,
	ActivityPage
} from './pages/index';


store.dispatch(
	{
		type: "serverState/init",
		payload: {}
	}
);

// This reducer:
// - sets loginPage as the first page
// - reads into state.appStates.storage_data_js
//    uid, pwd if available in window.localStorage
// - reads into state.appStates.search_params_js
//    app name if available from URLSearchParams(window.location.search)
store.dispatch(
	{
		type: "appStates/init",
		payload: { page: "loginPage", props: {} }
	}
);
store.dispatch(
	{
		type: "dataStates/setDataIDTokensCue",
		payload: { data_id_tokens_cue_js: {} }
	}
);

const App = () => {

	const current_page = useSelector( (state) => getCurrentPage(state) );
	const current_page_props = useSelector( (state) => getCurrentPageProps(state) );

	const [current_page_jsx, setCurrentPageJSX] = useState(<div>Loading...</div>);


	useEffect( () => {
		let jsx;

		switch (current_page) {
			case "loginPage":
				jsx = <LoginPage />;
				break;
			case "loadingPage":
				jsx = <LoadingPage />;
				break;
			case "selectAppPage":
				jsx = <SelectAppPage />;
				break;	
			case "appPage":
				jsx = <AppPage />;
				break;
			case "activityPage":
				jsx = <ActivityPage />;
				break;										
			default:
				jsx = <></>;
		}

		setCurrentPageJSX(jsx);
		
	}, [
		current_page,
		current_page_props
	]);

	return (
		<div className="App">
			{current_page_jsx}
		</div>
	);
}

export default App;
